<template>
  <CartCheckoutWrapper>
    <div class="basket-wrapper">
      <section class="section">
        <div class="container">
          <div class="row">
            <div class="col-sm-12 col-lg-9">
              <div class="table-responsive">
                <table class="table cart-table" cellspacing="0">
                  <thead>
                  <tr>
                    <th class="product-remove">&nbsp;</th>
                    <th class="product-thumbnail" id="header">Preview</th>
                    <th class="product-name" id="header">Description</th>
                    <!-- <th class="product-price">Price</th> -->
                    <th class="product-box-size" id="header">Quantity</th>
                    <!-- <th class="product-quantity"># Boxes</th> -->
                    <th class="product-subtotal" id="header">Total</th>
                  </tr>
                  </thead>
                  <tbody>
                  <LineItem
                    :data-url="line.url"
                    v-for="line in basketLines"
                    :key="line.url"
                    :line="line"
                    @remove="onRemove"></LineItem>
                  </tbody>
                </table>
              </div><!-- /.table-responsive -->
            </div>
            <div class="col-3 d-none d-lg-block">
              <div class="cart-subtotal action-card">
                <h2 class="subtotal">Subtotal: ${{subtotalPrice.toFixed(2)}}</h2>
                <hr/>
                <router-link to="/checkout" class="btn-action proceed-to-checkout" style="margin-bottom: 12px;">
                  Checkout
                  <i class="fa fa-arrow-right"></i>
                </router-link>
                <p class="continue-shopping">or <router-link to="/business-cards">continue shopping</router-link></p>
              </div>
              <div class="cart-voucher action-card">
                <template v-if="basketVoucher">
                  <h2>Discount Code applied</h2>
                  <hr>
                  <b>Name:</b> {{basketVoucher.name}}
                  <hr>
                  <p v-if="!enteringVoucher" class="continue-shopping"><a @click="enteringVoucher = true">change coupon</a></p>
                </template>
                <template v-else>
                  <h2>Have a Discount Code?</h2>
                  <hr/>
                </template>
                <template v-if="enteringVoucher || !basketVoucher">
                <!-- <MessageFormGroup> -->
                  <b-input-group>
                    <b-form-input size="sm" class="voucher-input" v-model="voucher" placeholder="Code" />
                    <div class="input-group-append">
                      <b-btn size="sm" class="apply-voucher-btn" @click="applyVoucherCode" variant="default">Apply</b-btn>
                    </div>
                  </b-input-group>
                  <!-- </MessageFormGroup> -->
                  <div class="error" v-if="voucherError">{{voucherError}}</div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="fixed-menu d-lg-none">
      <div class="fixed-menu-body" style="flex-direction: column;">
        <div v-if="enteringVoucher" class="discount-code">
          <h2>Have a Discount Code?</h2>
          <b-input-group>
            <b-form-input size="sm" class="voucher-input" v-model="voucher" placeholder="Code" />
            <div class="input-group-append">
              <b-btn size="sm" class="apply-voucher-btn" @click="applyVoucherCode" variant="default">Apply</b-btn>
            </div>
          </b-input-group>
          <div class="error" v-if="voucherError">{{voucherError}}</div>
          <p class="continue-shopping"><a href="#" @click.prevent="enteringVoucher = false">cancel</a> | <router-link to="/businesscards">continue shopping</router-link></p>
        </div>

        <div v-else>
          <h2 class="subtotal" style="margin-bottom: 12px">Subtotal: ${{subtotalPrice.toFixed(2)}}</h2>
          <router-link to="/checkout" class="btn-action proceed-to-checkout">
            Checkout
            <i class="fa fa-arrow-right"></i>
          </router-link>
          <p class="continue-shopping">
            <span v-if="basketVoucher">
              Code applied: <b>{{basketVoucher.name}}</b> <a href="#" @click.prevent="enteringVoucher = true">change</a>
            </span>
            <span v-else>
              <a href="#" class="enter-discount-code-link" @click.prevent="enteringVoucher = true">enter discount code</a>
            </span>
            | <router-link to="/businesscards">continue shopping</router-link></p>
        </div>
      </div>
    </div>
  </CartCheckoutWrapper>
</template>

<script>

  import LineItem from './LineItem'
  import {mapActions, mapGetters} from 'vuex';

  export default {
    components:{
      LineItem
    },
    data() {
      return {voucher: '', voucherError: null, enteringVoucher: false};
    },
    computed:{
      ...mapGetters(['subtotalPrice', 'basketLines', 'basketVoucher']),
    },
    methods:{
      ...mapActions(['loadBasket', 'changeNumberOfBoxes', 'removeFromCart', 'addVoucher', 'applyFutureVoucher']),
      onRemove(obj){
        this.removeFromCart(obj.line);
      },
      async applyVoucherCode() {
        this.voucherError = null;
        if (!this.voucher) {
          this.voucherError = "Enter a code";
          return;
        }
        try{
          await this.addVoucher(this.voucher);
          // Success
          this.voucher = '';
          this.voucherError = 'Code applied';
          // After a short delay, hide the field, clear the success message
          setTimeout(() => {
            this.enteringVoucher = false;
            this.voucherError = '';
          }, 1000);
        } catch(e) {
          this.voucherError = e;
        }
      }
    },
    async created() {
      await this.loadBasket();
      try {
        await this.applyFutureVoucher();
      } catch(e) {
        this.voucherError = e;
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import '~bootstrap/scss/_functions';
  @import '~bootstrap/scss/_variables';
  @import '~scss/colors';


  :host {
    font-family: $font-family-sans-serif !important;
  }

  .container{
    background-color: $gray-3;
  }

  .section{
    padding-top: 20px;
    height: 100vh;
    max-width:1100px;
    margin:0 auto;
    background-color: $gray-3;
  }

  #header{
    font-weight: 800;
  }


  .table {
    thead {
      .product-price {
        font-weight: bold;
      }
    }
  }

  .cart-table {
    .form-control {
      background-color: $white;
    }

    > tbody > tr:hover {
      background: white;
      box-shadow: 2px 4px 2px $gray-1;
      cursor: pointer;
    }

    > thead > tr > th {
      border-bottom: 1px solid $gray-2;
      font-weight: normal;
    }

    thead > tr, tbody > tr, tfoot > tr {
      > td, > th {
        vertical-align: middle;
        border-color: $gray-1;
      }
    }

    > thead > tr, > tbody > tr, > tfoot > tr {
      > td, > th {
        padding: .75rem;
      }
    }

    .variation {
      margin-top: 5px;

      > tbody > tr {
        > th {
          padding-right: 5px;
        }

        > td {
          color: $gray-0;
        }
      }

      p {
        margin-bottom: 0;
      }
    }

    td.actions {
      padding-right: 0;
      padding-left: 0;
      padding-top: 25px;
    }

    .actions {
      .coupon, .coupon .form-control {
        margin-bottom: 20px;
      }
    }

    .cart-totals {
      * > tr {
        > td, > th {
          padding-top: 10px;
          padding-bottom: 10px;
          font-weight: normal;
        }
      }

      > h2 {
        margin-top: 0;
        margin-bottom: 15px;
      }
    }

  }
  .cart-subtotal .subtotal {
    font-size: 20px;
  }
  .continue-shopping {
    text-align: center;
    margin: 0;
    padding: 0;
    a {
      color: get-theme-color('accent');
      font-weight: bold;
    }
  }

  .btn-action.proceed-to-checkout {
    margin: 0 auto 12px auto;
    display: block;
  }

  .cart-voucher .error {
    color: red;
  }

  .fixed-menu-body .discount-code .input-group {
    margin: 1em;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/basket/Basket.vue